<section class="section-white" *ngIf="reportData?.cards">
  <div class="section-container">
    <h2 class="section-heading">
      <span>{{ reportData?.header }}</span>
    </h2>
    <div class="responsive-padding-inline-96">
      <div class="center-container w-100">
        <div>
          <div class="flex-col gap-48">
            <div class="multi-row-grid">
              <div
                class="blog-container"
                *ngFor="let card of reportData?.cards"
              >
                <ng-container
                  *ngTemplateOutlet="figureTemplate; context: { item: card }"
                ></ng-container>
              </div>
            </div>
            <div class="single-row-scroll mar-t-24">
              <div class="blog-container-mobile" *ngFor="let card of reportData?.cards">
                <ng-container
                  *ngTemplateOutlet="figureTemplate; context: { item: card }"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #figureTemplate let-card="item">
      <ng-container *ngIf="card?.fields?.title">
        <div class="blog-image">
          <img
            class="responsive-radius-xl"
            src="{{
              card?.fields?.whitepapersAndReportsImage?.fields?.file?.url
            }}"
            alt="{{ card?.fields?.whitepapersAndReportsImage?.fields?.title }}"
          />
        </div>
        <div class="latest-news-content">
          <div class="badge" *ngIf="card?.fields?.category">
            {{ card?.fields?.category }}
          </div>
          <h5 class="latest-news-heading">
            {{ card?.fields?.title }}
          </h5>
          <div>
            {{ card?.sys?.createdAt | date: 'longDate' }} ·
            <span class="grey-500">{{ card?.fields?.readingTime }}</span>
          </div>
        </div>
        <a
          class="stretched-link"
          href="{{`about-us/resources/whitepapers-and-reports/` + card.fields.blogId | urlParams:queryParams }}"
          (click)="onWhitepaperClick(card?.fields?.title, 'about-us/resources/whitepapers-and-reports/' + card.fields.blogId)"
        ></a>
      </ng-container>
    </ng-template>
  </div>
</section>
